import React, { useState } from 'react';
import { Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { authApi } from '../api/api';

export default function ChangePassword() {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const update = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.next !== form.confirm) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      return;
    }
    if (form.next.length < 8) {
      setError('Das neue Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }

    setSaving(true);
    try {
      await authApi.changePassword(form.current, form.next);
      toast.success('Passwort erfolgreich geändert!');
      setForm({ current: '', next: '', confirm: '' });
    } catch (err) {
      setError(err.response?.data?.detail || 'Fehler beim Ändern des Passworts.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h4 className="text-white mb-4">🔑 Passwort ändern</h4>
      <Row>
        <Col md={5}>
          <Card bg="dark" text="white" className="border-secondary">
            <Card.Body className="p-4">
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Aktuelles Passwort</Form.Label>
                  <Form.Control
                    type="password"
                    value={form.current}
                    onChange={update('current')}
                    className="bg-dark text-white border-secondary"
                    required
                    autoComplete="current-password"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Neues Passwort</Form.Label>
                  <Form.Control
                    type="password"
                    value={form.next}
                    onChange={update('next')}
                    className="bg-dark text-white border-secondary"
                    required
                    autoComplete="new-password"
                    minLength={8}
                  />
                  <Form.Text className="text-muted">Mindestens 8 Zeichen.</Form.Text>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>Neues Passwort wiederholen</Form.Label>
                  <Form.Control
                    type="password"
                    value={form.confirm}
                    onChange={update('confirm')}
                    className="bg-dark text-white border-secondary"
                    required
                    autoComplete="new-password"
                    isInvalid={form.confirm.length > 0 && form.confirm !== form.next}
                  />
                  <Form.Control.Feedback type="invalid">
                    Passwörter stimmen nicht überein.
                  </Form.Control.Feedback>
                </Form.Group>
                <Button type="submit" variant="success" className="w-100" disabled={saving}>
                  {saving ? 'Speichere…' : '🔑 Passwort ändern'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
